import React, { useCallback } from 'react';

import { GenerateImagePageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';
import { notificationApi } from '../../adapters/get-notification';

export const GenerateImagePage = (props) => {
  const renderHelpButton = useCallback(popupId => (
    <HelpButton
      topic={popupId}
    />
  ), []);

  return (
    <GenerateImagePageComponent
      {...props}
      renderHelpButton={renderHelpButton}
      notificationApi={notificationApi}
      MultiLineEllipsisText={MultiLineEllipsisText}
    />
  );
};
